import { env } from "~/env";
import { getAxios } from "../axios";

export const instance = getAxios();

instance.defaults.baseURL = env.VITE_USE_PROXY ? "/api" : env.VITE_API_URL;
